import { BoxPropertyMap } from 'models';

export const areBoxPropertiesEqual = (property: BoxPropertyMap): boolean => property.every(value => value === property.last());
